<template>
    <div
        class="d-tag"
        :class="`color-${color}`"
    >
        <DIcon
            v-if="icon !== null"
            :name="icon"
        />
        {{ label }}
    </div>
</template>

<script>
export default {
    name: 'DTag',
    props: {
        color: {
            type: String,
            required: false,
            default: 'secondary'
        },
        label: {
            type: String,
            required: true,
            default: ''
        },
        icon: {
            type: String,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.d-tag {
    display: inline-block;
    justify-self: flex-start;
    background: var(--colorSecondaryLight);
    color: var(--colorPrimaryText);
    border-radius: 5px;
    font-size: 12px;
    padding: 5px 10px;

    &.color-primary {
        background: var(--colorPrimaryLight);
        color: var(--colorPrimaryText);
    }
    &.color-secondary {
        background: var(--colorSecondaryLight);
        color: var(--colorPrimaryText);
    }
    &.color-danger {
        background: var(--colorDangerLight);
        color: var(--colorPrimaryText);
    }
    &.color-success {
        background: var(--colorSuccessLight);
        color: var(--colorPrimaryText);
    }
    &.color-purple {
        background: var(--colorPurple);
        color: var(--colorPrimaryText);
    }
    &.color-info {
        background: var(--colorInfo);
        color: var(--colorPrimaryText);
    }
}
</style>
